/**
 * Login / register functionality class
 */
class LoginRegister {
  /**
   * @constructor
   */
  constructor() {
    this._addResendButtonListener();
  }
/**
  * Add listener to resend code button.
  */
  _addResendButtonListener() {
    const resendButton = document.querySelector('button.resend-code-button');
    if (!resendButton) return;

    resendButton.addEventListener('click', (e) => {
      const resendInput = document.querySelector('input#resend-code');
      if (!resendInput) return;
      resendInput.disabled = false;
      const loginForm = document.querySelector('form.login-form');
      if (loginForm) loginForm.submit();
    });
  }
}

module.exports = LoginRegister;
